export const FLAG_DISBURSEMENT_SERVICE_FEES = 'disbursement-service-fees';
export const FLAG_SHOW_DISBURSEMENT_DATE = 'show-key-dates-disbursement-date';
export const FLAG_ENABLE_DISBURSEMENT_CHECK_SECURE_PULL_PRINT =
  'enable-disbursement-check-secure-pull-print';
export const FLAG_SHOW_ADD_ORGANIZATION_TO_ORDER_BUTTON =
  'show-add-organization-to-order-button';
export const FLAG_SHOW_CREATE_NEW_ORGANIZATION_PANEL =
  'show-create-new-organization-panel';
export const FLAG_SHOW_IMPORT_FROM_GLOBAL_ADDRESS_BOOK_CONTACT_FIELD =
  'show-import-from-global-address-book-contact-field';

export enum OrderTeamFeatures {
  EditOrderParties = 'order-team-eop',
  EditOrderPartiesVesting = 'order-team-eop-vesting',
  BulkDisbursements = 'order-team-bd',
  PartyRollOutTypes = 'order-team-eop-party-types-roll-out',
}
export enum WireInstructionFeatures {
  displayWiresLatestActivity = 'display-wires-latest-activity',
  WIRES_INDEFINITE_AUTH_FLAG = 'wires-indefinite-authorization-flag',
  showPaidDate = 'show-paid-date',
}
export enum DocumentIDPFeatures {
  DocumentsIdp = 'cf-documents-idp',
}
export enum DocumentUploadFeatures {
  EnableCustomerDocumentUploadLimit = 'enable-customer-documents-upload-max-limit',
}
export enum SANDAFeatures {
  SANDAIntegrationLink = 'show-sanda-integration-link',
}

export enum UserFeatures {
  UserReactivationOrderTeamParties = 'user-reactivation-orders-team-parties-tab',
}
